export function doesAnyLayerHavePhotoImages(design) {
  const layers_allow_photo_images = design.layer_set.filter(
    (layer) => layer.photo_image,
  );
  return layers_allow_photo_images.length > 0;
}

//export function getPrintOptionDetails(option) {
//  let result = {
//    name: option.name,
//    print_colors: 0
//  }
//option.layer_set.forEach((layer) => {
//  if (layer.has_print_color) { //TODO probably want to check print_color_from_layer here and not count it
//    result.print_colors++;
//  }
//})
//
//return result
//}

//export function getSelectedPrintOptionDetails(design) {
//  return getPrintOptionDetails(design.print_options[design.selected_print_option])
//}
